// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"ebe79ed2","186":"df645165","344":"4bdad65c","372":"e0fa1a80","377":"440c6e38","630":"a11331e4","738":"f75807a1","841":"c9e4cfe3","856":"26efed30"}[chunkId] + ".chunk.js";
};